module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_PLAFOND_CHROMATIC_CH2_1039_HAUTEUR_3000.89466629.png";